import React from "react";
import Text from "../../../../../../shared-components/css-modules/lexus/atoms/Text";
import Button from "../../../../../../shared-components/css-modules/lexus/atoms/Button";
import List from "../../../../../../shared-components/css-modules/lexus/atoms/List";
import Icon from "../../../../../../shared-components/css-modules/lexus/atoms/Icon";
import styles from "./Packs.module.scss";
import { scrollToTarget } from "../../../../../../../../common-deprecated/utils/scrollUtils";
import { CarConfigConfigureSectionsLbx } from "../../../../../utils/types/SectionTypesLbx";
import { CarConfigLabel } from "../../../../../utils/labelUtils";

export type Props = {
    index: number;
};

const Cta: React.FC<Props> = (props): JSX.Element => {
    const { index } = props;
    const handleClick = (target: string): void => {
        scrollToTarget(target);
    };

    return (
        <article
            className={styles.cta}
            style={{
                "--or-animation-delay": `${(index + 1) * 100 + 4}`,
            }}
        >
            <Text tag="h3" variant="apheleia-h4" className={styles["pack-title"]}>
                <CarConfigLabel label="carConfigLbxUpsellPacksTitle" />
            </Text>
            <List tag="ul" variant="checkmarks">
                <CarConfigLabel label="carConfigLbxUpsellPacksItems" useHTML />
            </List>
            <Button
                variant="btn-default"
                sizing="full-width"
                onClick={() => handleClick(CarConfigConfigureSectionsLbx.AtmosphereGrade)}
            >
                <CarConfigLabel label="carConfigLbxBackToAtmospheres" />
                <Icon variant="arrow-right" sizing="md" aria-hidden="true" />
            </Button>
        </article>
    );
};

export default Cta;
